export default "__VITE_ASSET__VSFSj$TF__"